import { useEffect } from 'react';
import { fireRoktPageView } from 'utils/adUtils';

/**
 * Fires a Rokt SDK+ page view event on mount (US only, SDK+ flag gated).
 *
 * @param {object} options
 * @param {string} options.pagetype   - Rokt pagetype value (e.g. 'Auth', 'MyAccount')
 * @param {string} options.screenname - Rokt screenname value (e.g. 'Sign In')
 * @param {string} options.title      - Hardcoded page title per Rokt spec
 */
const useRoktPageView = ({ pagetype, screenname, title }) => {
    // fire only on mount — Rokt page views must not re-fire on prop change per SDK+ spec
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        fireRoktPageView({ pagetype, screenname, title });
    }, []);
};

export default useRoktPageView;
